import { signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";
import { ref, get, set } from "firebase/database";
import { auth, db } from "../utils/db";
import { useHistory } from "react-router-dom";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
import {
  IonButton,
  IonCardTitle,
  IonCol,
  IonContent,
  IonInput,
  IonInputPasswordToggle,
  IonLabel,
  IonPage,
  IonRouterLink,
  IonRow,
  IonText,
  useIonToast,
} from "@ionic/react";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [presentToast] = useIonToast();
  const history = useHistory();

  const login = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        senha
      );
      const user = userCredential.user;

      // Busca o usuário no database
      const userRef = ref(db, `users/${user.uid}`);
      const userSnap = await get(userRef);

      let userData;
      if (!userSnap.exists()) {
        // Se não existir, cria com o nome e role default
        const displayName = user.displayName || user.email.split("@")[0];
        await set(userRef, {
          email: user.email,
          name: displayName,
          role: "jogador",
        });
        userData = {
          uid: user.uid,
          email: user.email,
          name: displayName,
          role: "jogador",
        };
      } else {
        userData = { uid: user.uid, ...userSnap.val() }; // pega role do DB
      }

      onLogin(userData); // agora userData tem role
      history.push("/");
    } catch (err) {
      presentToast({
        header: "Erro ao logar",
        message: err.message,
        buttons: ["OK"],
      });
    }
  };

  return (
    <IonPage className="gray-page">
      <IonContent fullscreen>
        <div className="box">
          <IonRow>
            <IonCol size="12">
              <IonCardTitle>Login</IonCardTitle>
            </IonCol>
          </IonRow>
          <IonRow className="ion-margin-top ion-padding-top">
            <IonCol size="12">
              <IonLabel>Email</IonLabel>
              <IonInput
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12">
              <IonLabel>Senha</IonLabel>
              <IonInput
                placeholder="Senha"
                type="password"
                onChange={(e) => setSenha(e.target.value)}
                color="secondary"
              >
                <IonInputPasswordToggle color="tertiary" slot="end" />
              </IonInput>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12">
              <IonButton
                expand="full"
                shape="round"
                color="tertiary"
                onClick={login}
              >
                Entrar
              </IonButton>
            </IonCol>
          </IonRow>
          <IonRow className="ion-margin-top ion-padding-top">
            <IonCol size="12">
              <IonText>Você ainda não tem uma conta? </IonText>
              <IonRouterLink className="link" href="/register">
                Clique aqui.
              </IonRouterLink>
            </IonCol>
            <IonCol size="12">
              <IonText>Esqueceu a sua senha?</IonText>
              <IonRouterLink className="link" href="/password-reset">
                {" "}
                Clique aqui.
              </IonRouterLink>
            </IonCol>
          </IonRow>
        </div>
      </IonContent>
    </IonPage>
  );
}
